module.exports = __webpack_public_path__ + "static/media/thumbnailMisconception.ed380ee9.jpg";